import React, { useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import { theme } from './theme/theme';
import { GlobalStyle } from './theme/GlobalStyle';
import Navbar from './components/navbar/Navbar';
import HeroSection from './components/hero/HeroSection';
import ImageCarousel from './components/carousel/ImageCarousel';
import FeaturesSection from './components/features/FeaturesSection';
import PricingSection from './components/pricing/PricingSection';
import PanningSection from './components/panning/PanningSection';
import MobileAppsSection from './components/mobile/MobileAppsSection';
import WhyNeuralPrompt from './components/features/WhyNeuralPrompt';
import CanvasoftGallery from './components/canvasoft/CanvasoftGallery';
// import TikTokSection from './components/social/TikTokSection';
import YouTubeSection from './components/video/YouTubeSection';
import { notifyLandingVisit } from './services/visitNotifications';

function App() {
  useEffect(() => {
    notifyLandingVisit();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Navbar />
      <main>
        <HeroSection />
        <ImageCarousel />
        <FeaturesSection />
        <PricingSection />
        <PanningSection />
        <MobileAppsSection />
        <WhyNeuralPrompt />
        <CanvasoftGallery />
        {/* <TikTokSection /> */}
        <YouTubeSection
          videoId="JU5-Jc0LNCs"
          title="See NeuralPrompt in Action"
          subtitle="Watch how NeuralPrompt transforms your creative workflow"
        />
      </main>
    </ThemeProvider>
  );
}

export default App;
